module.exports = __WEBPACK_EXTERNAL_MODULE_161__;


//////////////////
// WEBPACK FOOTER
// external "gemini/lib/@waca/dashboard-common/dist/glass/controllers/BaseSlideoutActionHandler"
// module id = 161
// module chunks = 2